import { WidgetRenderOptions, WidgetJsonData } from '../../models/element-types';
import { RendererBase } from '../renderer-base';

export abstract class BaseWidgetRenderer<TWidgetJsonData extends WidgetJsonData> extends RendererBase<TWidgetJsonData, WidgetRenderOptions> {
    protected renderElement(widgetJsonData: WidgetJsonData, options: WidgetRenderOptions = {}): HTMLElement {
        const wrapper = document.createElement('div');
        wrapper.id = widgetJsonData.id;

        const content = this.renderContent(widgetJsonData, options);
        wrapper.appendChild(content);

        wrapper.dataset['element'] = 'widget';
        wrapper.dataset['widget'] = widgetJsonData.type.toLowerCase();
        this.applyAdditionalAttributes(wrapper, widgetJsonData);
        this.applyCustomCssClasses(wrapper, widgetJsonData.cssClasses, options);

        return wrapper;
    }

    public rerender(element: HTMLElement, widgetJsonData: TWidgetJsonData, options: WidgetRenderOptions = {}): void {
        const oldContent = element.querySelector('.element-content');
        if (oldContent) {
            oldContent.remove();
        }

        const newContent = this.renderContent(widgetJsonData, options);
        element.appendChild(newContent);

        this.applyAdditionalAttributes(element, widgetJsonData);

        this.updateData(element, widgetJsonData);
    }

    protected override applyVisualProperties(element: HTMLElement, data: TWidgetJsonData): void {
        this.applyAdditionalAttributes(element, data);
    }

    protected applyCustomCssClasses(element: HTMLElement, cssClasses?: string[], options: WidgetRenderOptions = {}): void {
        const isEditor = options.runtimeContext?.mode?.toLocaleLowerCase() === 'editor';
        if (isEditor) {
            return; // we don't add custom classes in the constructor because it may affect the constructor elements.
        }

        if (cssClasses && cssClasses.length > 0) {
            element.classList.add(...cssClasses);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected applyAdditionalAttributes(element: HTMLElement, widgetJsonData: WidgetJsonData): void {
    }

    protected abstract renderContent(widget: WidgetJsonData, options: WidgetRenderOptions): HTMLElement;
}
